const resolveCatalogSocialId = (socialId) => {
  if (!socialId) return null;
  if (typeof socialId === "string") return socialId;
  return socialId._id ?? null;
};

const findCatalogSocial = (socialId, catalogSocials = []) => {
  const catalogId = resolveCatalogSocialId(socialId);
  if (!catalogId) return null;

  return catalogSocials.find((item) => item._id === catalogId) ?? null;
};

export const resolveSocialMeta = (socialId, catalogSocials = []) => {
  const catalogSocial = findCatalogSocial(socialId, catalogSocials);
  if (catalogSocial) return catalogSocial;

  if (typeof socialId === "object" && socialId !== null) {
    return socialId;
  }

  return null;
};

export const getSocialIcon = (socialId, catalogSocials = []) =>
  resolveSocialMeta(socialId, catalogSocials)?.icon;

/** Format socials for PATCH: UUID _id + full populated social_id object. */
export const formatSocialsForApi = (socials = [], catalogSocials = []) =>
  socials.map(({ _id, url, social_id }) => ({
    _id,
    url: url ?? "",
    social_id: resolveSocialMeta(social_id, catalogSocials) ?? social_id,
  }));

/** Ensure social_id has icon/label when API returns only an id reference. */
export const enrichSocialsForDisplay = (socials = [], catalogSocials = []) =>
  socials.map((social) => {
    const socialMeta = resolveSocialMeta(social.social_id, catalogSocials);
    if (!socialMeta) return social;

    return {
      ...social,
      social_id: socialMeta,
    };
  });
